import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { NavService } from '../../../services/nav.service';
import * as feather from 'feather-icons';
import { CustomizerService } from '../../../services/customizer.service';
import { NetsolinService } from 'src/app/shared/services/netsolin.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { OappService } from '../../../services/oapp.service';
@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnInit, AfterViewInit {

  constructor(public navServices: NavService, public customizer: CustomizerService, public netsolinS:NetsolinService, public globalS: GlobalService, private oapp:OappService) {   }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  buscaNit(nit){
    var search = this.oapp.nits_prefijosbd.find(x => x.nit == nit);
    var retorna = false;
    if(search!=undefined){
       retorna = true;
    }
    return retorna;
  }


}
